import { ref, watchEffect } from 'vue';
import { LocalizedText } from '@menu/Types/Objects/LocalizedText';
import getRestaurant from '@menu/Utils/getRestaurant';
import getSharedData from '@menu/Utils/getSharedData';

const RTL_LANGUAGE_CODES: string[] = [
  'ar',
  'fa',
  'he',
  'ur',
  'ps',
  'sd',
  'dv',
  'ku',
  'ug',
  'yi',
];

const messages = getSharedData().localizedMessages;

const restaurant = getRestaurant();

const defaultLanguageCode = ref<string>(restaurant.languages[0]);

const currentLanguageCode = ref<string>(restaurant.languages[0]);

function trans(key: string): string {
  return messages?.[currentLanguageCode.value]?.[key] ?? key;
}

function localize(
  localizedText: LocalizedText | null | undefined,
  { fallbackToEn }: { fallbackToEn?: boolean } = {},
): string | null {
  if (localizedText === null || localizedText === undefined) {
    return null;
  }

  return (
    localizedText[currentLanguageCode.value] ||
    localizedText[defaultLanguageCode.value] ||
    (fallbackToEn ? localizedText['en'] : null) ||
    ''
  );
}

function setCurrentLanguageCode(languageCode: string) {
  currentLanguageCode.value = languageCode;
}

function setupHtmlLangDirSync() {
  watchEffect(() => {
    const el = document.documentElement;
    el.setAttribute('lang', currentLanguageCode.value);
    el.setAttribute(
      'dir',
      RTL_LANGUAGE_CODES.includes(currentLanguageCode.value) ? 'rtl' : 'ltr',
    );
  });
}

export { trans, localize, setCurrentLanguageCode, setupHtmlLangDirSync };
